// src/pages/FixSolicitudes.jsx
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../components/Toast/useToast";

export default function FixSolicitudes() {
  const { user } = useAuth();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);

  const handleFix = async () => {
    if (!window.confirm('¿Estás seguro? Esto asignará companyId="cejm-default" a todas las solicitudes sin companyId')) {
      return;
    }

    try {
      setLoading(true);
      setResults(null);

      console.log('🔑 Obteniendo token...');
      const idToken = await user.getIdToken(true);
      console.log('✅ Token obtenido');
      
      const fixUrl = 'https://us-central1-firma-digital-db89b.cloudfunctions.net/fixSolicitudesSinCompanyId';
      console.log('📡 URL:', fixUrl);

      console.log('🔧 Ejecutando fix...');
      const response = await fetch(fixUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      console.log('📥 Respuesta recibida:', response.status);
      const data = await response.json();
      console.log('📦 Datos:', data);

      if (!response.ok || !data.ok) {
        throw new Error(data.message || data.error || `HTTP ${response.status}`);
      }

      console.log('✅ Fix completado:', data);
      setResults(data);
      
      showToast({
        type: 'success',
        message: `✅ ${data.totalFixed} solicitudes corregidas exitosamente`
      });

    } catch (error) {
      console.error('❌ Error completo:', error);
      showToast({
        type: 'error',
        message: `Error: ${error.message}`
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="header">
        <span className="badge">FIRMAS CEJM</span>
      </div>

      <h1 className="title">🔧 Fix: Solicitudes sin CompanyId</h1>

      <div className="card grid">
        <div style={{ 
          background: '#fef3c7', 
          padding: '16px', 
          borderRadius: '8px', 
          border: '2px solid #f59e0b',
          marginBottom: '20px'
        }}>
          <h3 style={{ color: '#92400e', marginBottom: '8px' }}>⚠️ Instrucciones:</h3>
          <ol style={{ color: '#78350f', marginLeft: '20px', lineHeight: '1.8' }}>
            <li>Este fix asignará <code>companyId = "cejm-default"</code> a todas las solicitudes que no tengan companyId</li>
            <li>Afecta 3 colecciones: <strong>work_requests</strong>, <strong>albaran_requests</strong>, <strong>requests</strong></li>
            <li>Solo se actualizan las que tienen <code>companyId = null</code></li>
            <li>Después del fix, <strong>TODAS</strong> las solicitudes serán visibles en el historial</li>
          </ol>
        </div>

        {!results && (
          <button 
            className="btn" 
            onClick={handleFix}
            disabled={loading}
            style={{ 
              padding: '16px 32px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            {loading ? '⏳ Ejecutando...' : '🔧 Ejecutar Fix Ahora'}
          </button>
        )}

        {results && (
          <div style={{ marginTop: '20px' }}>
            <div style={{ 
              background: '#dcfce7', 
              padding: '20px', 
              borderRadius: '8px', 
              border: '2px solid #10b981',
              marginBottom: '20px'
            }}>
              <h2 style={{ color: '#065f46', marginBottom: '16px' }}>
                🎉 Fix Completado Exitosamente
              </h2>
              <p style={{ color: '#047857', fontSize: '18px', fontWeight: 'bold', marginBottom: '16px' }}>
                ✅ {results.totalFixed} documentos corregidos en total
              </p>
              
              <div style={{ background: 'white', padding: '16px', borderRadius: '6px' }}>
                <h3 style={{ color: '#333', marginBottom: '12px' }}>📊 Detalle por colección:</h3>
                {results.results.map((r, idx) => (
                  <div key={idx} style={{ 
                    padding: '8px 0', 
                    borderBottom: idx < results.results.length - 1 ? '1px solid #e5e7eb' : 'none'
                  }}>
                    <strong>{r.collection}:</strong> {r.fixed} corregidas, {r.skipped} ya correctas ({r.total} total)
                  </div>
                ))}
              </div>
            </div>

            <div style={{ 
              background: '#dbeafe', 
              padding: '16px', 
              borderRadius: '8px', 
              border: '1px solid #3b82f6'
            }}>
              <h3 style={{ color: '#1e40af', marginBottom: '8px' }}>📋 Próximo paso:</h3>
              <p style={{ color: '#1e3a8a', marginBottom: '12px' }}>
                Ve al <strong>Historial de Solicitudes</strong> y verifica que ahora puedes ver todas las solicitudes (incluida la 26004008)
              </p>
              <button 
                className="btn" 
                onClick={() => window.location.href = '/historial-solicitudes'}
                style={{ width: '100%' }}
              >
                📋 Ir al Historial de Solicitudes
              </button>
            </div>
          </div>
        )}

        {loading && (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="spinner" style={{ margin: '0 auto 16px' }}></div>
            <p className="meta">Procesando solicitudes...</p>
            <p className="meta" style={{ fontSize: '12px', marginTop: '8px' }}>
              Esto puede tardar 30-60 segundos
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
